import React, { useState } from "react";
import SelectComponent from "./select";

const options = [
  { label: "This month", value: "month" },
  { label: "This week", value: "week" },
];

export default function SortByProject() {
  return <SelectComponent selectoptions={options} selected={options[0]} />;
}
